<template>
  <div id="matriz_peligro">
    <div class="col-sm-12 container bg-light">
      <div class="row justify-content-center">
        <div class="col-sm-11" id="col-nav-matriz-peligro">
          <ul class="nav nav-tabs" id="nav-tab" role="tablist">
            <li class="nav-item">
              <router-link
                id="mmp-tab"
                :to="{ name: 'registro_centro_trabajo' }"
                class="nav-link nav-link-matriz-peligro pt-3 pb-3"
                active-class="active"
                @click="cambiar_url('registro_centro_trabajo')"
                data-toggle="tab"
                role="tab"
                aria-controls="mmp"
                aria-selected="true"
              >
                Registro Centro de Trabajo
              </router-link>
            </li>
            <li class="nav-item">
              <router-link
                id="msp-tab"
                :to="{ name: 'seleccionar_proceso' }"
                class="nav-link nav-link-matriz-peligro pt-3 pb-3"
                active-class="active"
                @click="cambiar_url('seleccionar_proceso')"
                data-toggle="tab"
                role="tab"
                aria-controls="msp"
                aria-selected="false"
              >
                Seleccionar Proceso
              </router-link>
            </li>
            <li class="nav-item">
              <router-link
                id="mip-tab"
                class="nav-link nav-link-matriz-peligro pt-3 pb-3"
                active-class="active"
                data-toggle="tab"
                role="tab"
                aria-controls="mip"
                aria-selected="false"
                :to="{ name: 'identificar_peligros' }"
                @click="cambiar_url('identificar_peligros')"
              >
                Identificar Peligros
              </router-link>
            </li>
            <li class="nav-item">
              <router-link
                id="mer-tab"
                class="nav-link nav-link-matriz-peligro pt-3 pb-3"
                active-class="active"
                data-toggle="tab"
                role="tab"
                aria-controls="mer"
                aria-selected="false"
                :to="{ name: 'evaluacion_riesgos' }"
                @click="cambiar_url('evaluacion_riesgos')"
              >
                Evaluación De Riesgos
              </router-link>
            </li>
            <li class="nav-item">
              <router-link
                id="mmi-tab"
                class="nav-link nav-link-matriz-peligro pt-3 pb-3"
                active-class="active"
                data-toggle="tab"
                role="tab"
                aria-controls="mmi"
                aria-selected="false"
                :to="{ name: 'medidas_intervencion' }"
                @click="cambiar_url('medidas_intervencion')"
              >
                Medidas de Intervención
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="col-sm-11 container bg-light mt-2 matriz-peligro-content">
      <div class="tab-content pl-md-1 pr-md-1 pl-1 pr-1">
        <router-view></router-view>
      </div>
    </div>

    <Mtm />
  </div>
</template>

<script>
import Mtm from "@/components/Mtm.vue";

export default {
  name: "matriz-peligro",
  components: {
    Mtm,
  },
  data() {
    return {};
  },
  methods: {
    cambiar_url: function (state) {
      this.$store.state.estado_navbar_matriz_peligro = state;
    },
  },
  created() {
    if (!this.$store.state.email) {
      this.$router.replace("/");
      return;
    }
    if (!this.$store.state.estado_navbar_matriz_peligro)
      this.$router.push("/registro_centro_trabajo");
    else this.$router.push(this.$store.state.estado_navbar_matriz_peligro);
  },
};
</script>